import { Typography } from '@material-ui/core'
import { useState, useEffect } from 'react'
import { Container } from './styles'
import api from '../../config/api'
import DataTable from '../../components/DataTable'
import { ColDef } from '@material-ui/data-grid'
import { zonedTimeToUtc } from 'date-fns-tz'
import { useHistory } from 'react-router'




interface Productivity {
    id: number,
    cpf: number,
    year: Date,
    status: string,
    effective: boolean,
    total_brute: number,
    total_hire_cost: number,
    total_production_cost: number,
    total_liquid: number,
    user_id: number,
    fluid_process_id: number,
    created_at: Date,
    updated_at: Date
    productivity_items: ProductivityItem[]
}

interface ProductivityItem {
    id: number,
    productivity_id: number,
    quantity?: number | null,
    production: number,
    area?: number | null,
    value: number,
    production_cost: number,
    hired: boolean,
    hire_percentual: number,
    total_brute: number,
    total_hire_cost: number,
    total_production_cost: number,
    total_liquid: number,
    agro_product_id: number
}


function Productivitys() {

    const [productivitys, setProductivitys] = useState<Productivity[]>([])
    const [normalized, setNormalized] = useState<any[]>([])
    const history = useHistory()

    const columns: ColDef[] = [
        { field: 'id', headerName: 'ID', width: 60 },
        { field: 'status', headerName: 'Status', width: 200 },
        { field: 'fluid_process_id', headerName: 'Processo Fluid', width: 200 },
        { field: 'cpf', headerName: 'CPF do Associado', width: 150 },
        { field: 'effective', headerName: 'Efetivo', width: 100 },
        { field: 'user_id', headerName: 'Usuário', width: 100 },
        { field: 'created_at_date', headerName: 'Date de criação', width: 150 },
        { field: 'created_at_time', headerName: 'Hora de criação', width: 150 },
        { field: 'updated_at_date', headerName: 'Ultima data de atualização', width: 220 },
        { field: 'updated_at_time', headerName: 'Ultima hora de atualização', width: 220 },
    ];

    function handleClick(row: any) {
        const { id } = row.data
        history.push(`/productivitys/${id}`)
    }

    useEffect(() => {
        async function fetch() {

            const requestProductivitys = await api.get('/productivitys')
            setProductivitys(requestProductivitys.data.productivitys)

            const auxNormalized = requestProductivitys.data.productivitys.map((item: Productivity) => {

                const timezoneCreatedDate = zonedTimeToUtc(item.created_at, 'America/Sao_Paulo');
                const tzUpCreatedTime = timezoneCreatedDate.toLocaleTimeString()
                const tzCreatedDate = timezoneCreatedDate.toLocaleDateString()

                const timezonedUpdatedDate = zonedTimeToUtc(item.updated_at, 'America/Sao_Paulo');
                const tzUpdateTime = timezonedUpdatedDate.toLocaleTimeString()
                const tzUpdateDate = timezonedUpdatedDate.toLocaleDateString()


                return {
                    id: item.id,

                    status: item.status === 'waiting' ? 'Aguardando Análise' :
                        item.status === 'ready' ? 'Análise Completa' :
                            item.status === 'registered' ? 'Registrado no MUA' :
                                'Aguardando correção',
                    cpf: item.cpf,
                    effective: item.effective ? 'Efetivo' : 'Previsto',
                    fluid_process_id: item.fluid_process_id ? item.fluid_process_id : 'Não informado',
                    user_id: item.user_id,
                    created_at_date: tzCreatedDate,
                    created_at_time: tzUpCreatedTime,
                    updated_at_date: tzUpdateDate,
                    updated_at_time: tzUpdateTime,
                }
            })
            setNormalized(auxNormalized)
        }
        fetch()
    }, [])

    return (
        <Container>

            <Typography variant="h4" style={{ marginBottom: 10, fontWeight: 600 }}>
                Lista de Produtividade
            </Typography>
            <DataTable
                columns={columns}
                rows={normalized}
                handleClick={(row) => handleClick(row)}
            />
        </Container>
    )
}

export default Productivitys